import React from 'react';
import {
  Switch,
  Route,
} from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import { ROUTES } from 'constants/routes';

import {
  ClientInventoryRootPage,
  ClientInventoryResourcePage,
  ClientInventoryTrayPage,
  ClientInventorySeedPage,
} from './pages';

const ClientInventoryPage = (): JSX.Element => {
  const { path } = useRouteMatch();
  const resourceRoot = ROUTES.dashboard.inventory.client.resource.root;

  return (
    <Switch>
      <Route
        path={`${path}${resourceRoot}${ROUTES.dashboard.inventory.client.resource.selected.root}`}
        component={ClientInventoryResourcePage}
      />
      <Route path={`${path}${ROUTES.dashboard.inventory.client.tray.root}`} component={ClientInventoryTrayPage} />
      <Route path={`${path}${ROUTES.dashboard.inventory.client.seed.root}`} component={ClientInventorySeedPage} />
      <Route path={`${path}`} component={ClientInventoryRootPage} />
    </Switch>
  );
};

export default ClientInventoryPage;
